<template>
    <PageNotFound :notFoundText="notFoundText" />
</template>

<script>
import PageNotFound from '@/components/PageNotFound';
export default {
    name: 'NotFound',

    components: {
        PageNotFound,
    },

    computed: {
        notFoundText() {
            return this.$route.params.text || 'Страница не найдена';
        },
    },
};
</script>

<style scoped></style>
